module.exports = __webpack_public_path__ + "img/prev.1fa74168.png";